import { React } from "react";
import PropTypes from 'prop-types';
import { CartesianGrid, ComposedChart, Label, ReferenceArea, ReferenceDot, ReferenceLine, XAxis, YAxis } from "recharts";

const MyQuotientChart = props => {
    const PurpleZoneReferenceArea = (props) => {
        const x1 = props.x;
        const x2 = props.x + props.width;
        const y1 = props.y;
        const y2 = props.y + props.height;
        return (
            <svg>
                <polygon points={`${x1},${y1},${x2},${y1},${x1},${y2}`} style={{ fill: '#612F6F', opacity: 0.6 }} />
            </svg>
        )
    };
    const GreenZoneReferenceArea = (props) => {
        const x1 = props.x;
        const x2 = props.x + props.width;
        const y1 = props.y;
        const y2 = props.y + props.height;
        return (
            <svg>
                <polygon points={`${x1},${y2},${x2},${y1},${x2},${y2}`} style={{ fill: '#A0F8BD', opacity: 0.6 }} />
            </svg>
        )
    };
    const CustomReferenceDot = props => {
        return (
            <svg width="30" height="30" x={props.cx - 15} y={props.cy - 15} xmlns="http://www.w3.org/2000/svg">
                <g>
                    <title>Layer 1</title>
                    <path
                        fill="#ffff00"
                        stroke="#ffffaa"
                        d="m2.5,10.90327l8.40332,0l2.59669,-8.40327l2.59669,8.40327l8.40331,0l-6.79841,5.19345l2.59682,8.40327l-6.79842,-5.19359l-6.79841,5.19359l2.59682,-8.40327l-6.79841,-5.19345z"
                        id="svg_1"
                        strokeWidth="2"
                    />
                </g>
            </svg>
        );

    };

    const data = [
        { value: 0 }, { value: 0 }, { value: 0 }, { value: 0 },
        { value: 0 }, { value: 0 }, { value: 0 }, { value: 0 },
        { value: 0 }, { value: 0 }, { value: 0 }];

    return (
        <ComposedChart data={data} width={330} height={270}>
            <CartesianGrid stroke="#ccc" />
            <XAxis stroke="#4A618A" height={40} tickLine={false}
                type="number" domain={[0, 10]} ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}>
                <Label value="Children Desired" position="insideBottom"
                    style={{ textAnchor: 'middle', fill: '#4A618A', fontWeight: 'bold' }} />
            </XAxis>
            <YAxis stroke="#4A618A" tickLine={false}
                domain={[0, 10]} interval={0} ticks={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}>
                <Label angle={-90} value="Current Children" position="insideLeft"
                    style={{ textAnchor: 'middle', fill: '#4A618A', fontWeight: 'bold' }} />
            </YAxis>
            <ReferenceArea x1={0} y1={0} fill="white" />
            <ReferenceArea x1={0} x2={10} shape={<PurpleZoneReferenceArea />} />
            <ReferenceArea x1={0} x2={10} shape={<GreenZoneReferenceArea />} />
            <ReferenceLine stroke="yellow" strokeWidth={3}
                segment={[{ x: 0, y: 0 }, { x: 10, y: 10 },]} />
            <ReferenceLine stroke="purple" strokeWidth={3}
                segment={[
                    { x: 0, y: props.currentChildren },
                    { x: props.desiredChildren, y: props.currentChildren }
                ]} />
            <ReferenceLine
                stroke="purple" strokeWidth={3}
                segment={[
                    { x: props.desiredChildren, y: 0 },
                    { x: props.desiredChildren, y: props.currentChildren }
                ]} />
            <ReferenceDot
                x={props.desiredChildren}
                y={props.currentChildren}
                r={10} fill="purple"
                stroke="#ededed"
                strokeWidth={3}
                shape={props.currentChildren === props.desiredChildren ? CustomReferenceDot : null}
            />
        </ComposedChart>
    );
};

MyQuotientChart.propTypes = {
    currentChildren: PropTypes.number,
    desiredChildren: PropTypes.number
};

export default MyQuotientChart;
